import * as React from "react";
const SvgFiRrTabletRugged = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.414 5.586A2 2 0 0 0 22 4.172V2.5A2.5 2.5 0 0 0 19.5 0h-1.672a2 2 0 0 0-1.414.586L16 1H8L7.586.586A2 2 0 0 0 6.172 0H4.5A2.5 2.5 0 0 0 2 2.5v1.672a2 2 0 0 0 .586 1.414L3 6v2l-.414.414A2 2 0 0 0 2 9.828v4.343a2 2 0 0 0 .586 1.414l.414.414v2l-.414.414A2 2 0 0 0 2 19.827v1.672a2.5 2.5 0 0 0 2.5 2.5h1.672a2 2 0 0 0 1.414-.586L8 22.999h8l.414.414a2 2 0 0 0 1.414.586H19.5a2.5 2.5 0 0 0 2.5-2.5v-1.672a2 2 0 0 0-.586-1.414L21 17.999v-2l.414-.414A2 2 0 0 0 22 14.171V9.828a2 2 0 0 0-.586-1.414L21 8V6zM5 21V3h14v18z"
    />
  </svg>
);
export default SvgFiRrTabletRugged;
